import React from 'react';
import { compose } from 'redux';
import { withContent } from 'components/Content';
import Gulch from 'components/Gulch';
import Hero from 'components/Hero';
import OurServices from 'components/OurServices';
import PromoBanner, { CHANNELS } from 'components/Promos/Banner';
import withLanding from '../../Landing/withLanding';
import { pages as PAGES } from '../../Landing/constants';
import ProductShowcase from '../ProductShowcase';
import BrandStory from '../BrandStory';
import Filtration from '../Filtration';
import styles from './comm.scss';

const CONTENT_KEYS = {
  hero: 'Hero',
  services: 'Our Services',
  showcase: 'Products Showcase',
  story: 'Brand Story',
  filtration: 'Filtration',
  leads: 'Leads',
};

const Commercial = ({ content }) => (
  <div className={styles.comm}>
    <PromoBanner channel={CHANNELS.acq} />
    <Hero content={content.hero} />
    <OurServices content={content.services} />
    <Gulch />
    <ProductShowcase content={content.showcase} />
    <BrandStory content={content.story} />
    <Filtration content={content.filtration} />
  </div>
);

export default compose(
  withLanding(PAGES.office),
  withContent(CONTENT_KEYS),
)(Commercial);
